import { remainingDaysUiText } from "../../../../../sharedmailbox/common/TrialAddon/util";

export const CURRENT_PLAN_LABEL = 'Current plan';
export const TRIAL_PLAN_LABEL = 'Ongoing Trial';

// Plan card CTA
export const UPGRADE_PLAN_BUTTON_TEXT = 'Upgrade now';
export const UPGRADE_TO_ANNUAL_BUTTON_TEXT = 'Move to Annual';

export const DAYS_BETWEEEN_TRIALS_THRESHOLD = 90;

export const GET_PLAN_TRIAL_ALERT = (planName, daysLeft) => (
    `Your free trial of ${planName} plan ends ${remainingDaysUiText(daysLeft)}`
);
export const LEGACY_PLAN_ALERT = 'You are on a legacy plan right now. To upgrade, please select one of our latest plans below.';

// GAINSIGHT TRACKING EVENTS
export const EXPLORE_YOUR_PLAN_TRACKING_EVENTS = {
    PLAN_TRIAL_STARTED: 'HigherPlanTrialStarted',
    UPGRADE_DURING_PLAN_TRIAL: 'UpgradeDuringPlanTrial',
    SIDEBAR_CLICKED: 'ExplorePlansSidebarClicked',
}

export const UPGRADE_PLAN_ROUTE_URL = '/app/settings/account/upgrade';

//Enums for Feature names
export const PlanFeatures = {
    USERS: 'Users',
    LIVE_CHAT: "Live chat",
    KNOWLEDGE_BASE: "Knowledge Base with no branding and no publishing limits",
    WHATSAPP_MESSAGING : "WhatsApp messaging",
    TEAM_COLLABORATION: "Team collaboration",
    SHAREABLE_PERMALINKS: "Shareable permalinks",
    VOICE_INBOXES_DIALER: "Voice inboxes & Dialer",
    SHARED_VIEWS: "Shared views for deeper collaboration",
    WORKLOAD_DISTRIBUTION: "Workload distribution",
    RULE_BASED_AUTOMATIONS: "Rule-based automations",
    SLA_BUSINESS_HOURS: "SLA reports & business hours",
    REPORTS_DASHBOARDS: "Custom reports & dashboards",
    ADVANCED_LIVE_CHAT_CONTROLS: "Advanced live chat controls",
    OUT_BOX_INTEGRATIONS: "Out of the box integrations",
    ADVANCED_USER_ROLES: "Advanced user roles",
    TIME_BASED_AUTOMATIONS: "Time based automations",
    SLA_REMINDERS: "SLA policy and violation reminder",
    SLA_REMINDER_PLURAL: "SLA policies and violation reminders",
    R_R_AUTO_ASSIGNMENT: "Round robin auto-assignments with assignment limits",
    SKILL_BASED_ASSIGNMENTS: "Skill based auto-assignments",
    CUSTOM_REPORTS_DASHBOARDS: "Custom reports & dashboards",
    HARVEY_AI_BOT: "Harvey AI",
    OKTA_INTEGRATION: "Okta app integration",
    SHARED_MAILBOXES: "Shared email inboxes",
    DEFAULT_USER_ROLES: "Default user roles",
    IOS_ANDROID_APPS: "iOS & Android mobile apps",
    ONBOARDING_ASSISTANCE: "Onboarding and 24x7 support",
    CHAT_EMAIL_SUPPORT: "24x7 chat & email support",
    SUPPORT: "24x7 Support",
    SHARED_CONTACTS_COMPANIES: "Shared contacts & companies",
    HIPAA_COMPLIANCE: "HIPAA compliance",
    PRIORITY_SUPPORT: "Priority support",
    CALL_BACK_SUPPORT: "Book a call with Hiver support",
    UPTIME_SLA: "Uptime SLA",
    DEDICATED_SUCCESS_MANAGER: "Dedicated success manager",
    QUATERLY_TRAININGS: "Quarterly team trainings",
    CUSTOM_BUILD_HOURS: 'Custom build hours',
    CHATBOTS: 'Chatbots',
    ZAPIER_INTEGRATION: 'Zapier Integration',
    SLA_VIOLATION: 'SLA Violation',
    CONVERSATION_REPORTS: 'Analytics for conversation data',
    HIVER_APIS: 'Hiver APIs',
    AUTOMATIONS: 'Workflow automations',
    EMAIL_TEMPLATES: 'Email templates with attachments',
    EMAIL_MANAGEMENT: 'Email management',
    A_J_S_Q_INTEGRATIONS: 'Asana, Jira, Slack, and Quickbooks Integrations',
    AI_SUMMARIZER: 'AI summarizer',
    USER_CSAT_REPORTS: 'Analytics– User, tag, CSAT reports',
    SALESFORCE_ZAPIER: 'Salesforce and Zapier Integration',
    SCHEDULED_DATA_E_AND_R: 'Scheduled data exports and reports',
    SHARED_LABELS: 'Shared Labels',
    MULTI_CHANNEL_ENGAGEMENT: 'Multi-channel engagement, including channels like Email, Live Chat, Voice and WhatsApp',
    KNOWLEDGE_BASE_WITH_ARTICLE_LIMIT: 'Knowledge Base with branding and publishing limits on articles',
    ROUND_ROBIN_AUTO_ASSIGNMENT: 'Round-robin auto-assignment',
    CSAT_SURVEY: 'CSAT survey',
    ADVANCED_ANALYTIC_REPORT: 'Advanced analytics and reports',
    API_ACCESS: 'API access',
    CUSTOM_FIELDS_PER_MAILBOX: 'Custom fields per mailbox',
    SLACK_INTEGRATION: 'Slack integration',
    CUSTOM_FIELDS: 'Custom fields',
    CHAT_TRANSCIPTS: 'Chat transcripts',
    ARTICLES_IN_CHAT: 'Help articles in chat',
    INTERNAL_KNOWLEDGE_BASE: 'Internal Knowledge Base',
}

/**
 * This is featured list excluding add-on features (shared mailbox, no of users etc) 
 * for specifying relative order of features throughout all plans.
 *  */ 
export const ORDERED_FEATURES_LIST = [
    PlanFeatures.EMAIL_TEMPLATES,
    PlanFeatures.VOICE_INBOXES_DIALER,
    PlanFeatures.R_R_AUTO_ASSIGNMENT,
    PlanFeatures.ROUND_ROBIN_AUTO_ASSIGNMENT,
    PlanFeatures.SKILL_BASED_ASSIGNMENTS,
    PlanFeatures.LIVE_CHAT,
    PlanFeatures.MULTI_CHANNEL_ENGAGEMENT,
    PlanFeatures.CHATBOTS,
    PlanFeatures.AI_SUMMARIZER,
    PlanFeatures.HARVEY_AI_BOT,
    PlanFeatures.OKTA_INTEGRATION,
    PlanFeatures.KNOWLEDGE_BASE,
    PlanFeatures.TEAM_COLLABORATION,
    PlanFeatures.KNOWLEDGE_BASE_WITH_ARTICLE_LIMIT,
    PlanFeatures.EMAIL_MANAGEMENT,
    PlanFeatures.HIVER_APIS,
    PlanFeatures.API_ACCESS,
    PlanFeatures.SLA_REMINDERS,
    PlanFeatures.SLA_REMINDER_PLURAL,
    PlanFeatures.SLA_BUSINESS_HOURS,
    PlanFeatures.A_J_S_Q_INTEGRATIONS,
    PlanFeatures.SALESFORCE_ZAPIER,
    PlanFeatures.CONVERSATION_REPORTS,
    PlanFeatures.ADVANCED_ANALYTIC_REPORT,
    PlanFeatures.USER_CSAT_REPORTS,
    PlanFeatures.CSAT_SURVEY,
    PlanFeatures.CUSTOM_REPORTS_DASHBOARDS,
    PlanFeatures.SCHEDULED_DATA_E_AND_R,
    PlanFeatures.WHATSAPP_MESSAGING,
    PlanFeatures.IOS_ANDROID_APPS,
    PlanFeatures.HIPAA_COMPLIANCE,
    PlanFeatures.CALL_BACK_SUPPORT,
    PlanFeatures.QUATERLY_TRAININGS,
    PlanFeatures.CUSTOM_BUILD_HOURS,
    PlanFeatures.UPTIME_SLA,
    PlanFeatures.DEDICATED_SUCCESS_MANAGER,
    PlanFeatures.ONBOARDING_ASSISTANCE,
    PlanFeatures.CHAT_TRANSCIPTS,
    PlanFeatures.CHAT_EMAIL_SUPPORT,
    PlanFeatures.SUPPORT,
    PlanFeatures.ARTICLES_IN_CHAT,
    PlanFeatures.INTERNAL_KNOWLEDGE_BASE,
]

export const DEFAULT_TRIAL_EXTEND_DAYS = 1;

